import { createModel, type DataFromSchema } from "models/Model";
const required = true;

export enum EmployeeRoles {
  TECHNICIAN = "technician",
  MEASURE_LITE = "measure_lite",
  BUYER = "buyer",
  ADMIN = "admin",
  CUST_SERV = "cust_serv",
  DESIGN = "design",
  SALES = "sales",
  LATHAM_ADMIN = "latham_admin",
  BRIGHT_ADMIN = "bright_admin",
}

export enum EmployeeStatus {
  ACTIVE = "active",
  INACTIVE = "inactive",
}

const employeeSchema = {
  name: { type: "text", label: "Name", required },
  email: { type: "email", label: "Email", required },
  role: { type: "radio", label: "Role", values: EmployeeRoles, required },
  phone: { type: "tel", label: "Contact Phone" },
  dealerId: { type: "text", label: "Company" },
  createdAt: { type: "date", label: "Created" },
  signedTOS: { type: "text", label: "TOS Signed?" },
  isActive: { type: "toggle", label: "Status", values: EmployeeStatus },
} as const;

const employeeSchemaModel = {
  name: { type: "text", label: "Name", required },
  email: { type: "email", label: "Email", required },
  role: { type: "radio", label: "Role", values: EmployeeRoles, required },
  phone: { type: "tel", label: "Contact Phone" },
  dealerName: { type: "text", label: "Company" },
  createdAt: { type: "date", label: "Created" },
  signedTOS: { type: "text", label: "TOS Signed?" },
  isActive: { type: "toggle", label: "Status", values: EmployeeStatus },
} as const;

type EmployeeMetaData = {
  id: string;
  createdAt?: string;
  dealerId: string;
  dealerName?: string;
};

export type Employee = DataFromSchema<typeof employeeSchema> & EmployeeMetaData;

export const EmployeeModel = createModel<Employee>(employeeSchemaModel);
